<form [formGroup]="addressForm.getForm()" novalidate class="address-form">
	<!-- Address Line 1 -->
	<mat-form-field>
		<mat-label id="address-line-1">{{ 'payment-panel-address_address-line-1' | translate }}</mat-label>
		<input
			matInput
			[formControl]="addressForm.getControl('line1')"
			aria-labelledby="address-line-1"
			data-cy="address-line-1"
			name="line1"
			class="fullstory-ignore"
			autocomplete="address-line1">
		<!-- Error message -->
		@if (addressForm.getFieldError('line1', 'required')) {
			<mat-error>
				{{ 'payment-panel-address_form-validation-address-line-1-required' | translate }}
			</mat-error>
		}
	</mat-form-field>
	<!-- Address Line 2 -->
	<mat-form-field>
		<mat-label id="address-line-2">{{ 'payment-panel-address_address-line-2' | translate }}</mat-label>
		<input
			matInput
			[formControl]="addressForm.getControl('line2')"
			aria-labelledby="address-line-2"
			name="line2"
			class="fullstory-ignore"
			autocomplete="address-line2"
			maxlength="100">
		<!-- Error message -->
		@if (addressForm.getFieldError('line2', 'maxlength')) {
			<mat-error>
				{{ 'payment-panel-address_form-validation-address-line-2-maxlength' | translate }}
			</mat-error>
		}
	</mat-form-field>
	<section class="address-form-row">
		<!-- Address City -->
		<mat-form-field class="medium-height">
			<mat-label id="address-city">{{ 'payment-panel-address_city' | translate }}</mat-label>
			<input
				matInput
				[formControl]="addressForm.getControl('city')"
				aria-labelledby="address-city"
				data-cy="city"
				class="fullstory-ignore"
				autocomplete="address-level2"
				maxlength="50">
			<!-- Error message -->
			@if (addressForm.getFieldError('city', 'required')) {
				<mat-error>
					{{ 'payment-panel-address_form-validation-address-city-required' | translate }}
				</mat-error>
			}
			@if (addressForm.getFieldError('city', 'maxlength')) {
				<mat-error>
					{{ 'payment-panel-address_form-validation-address-city-maxlength' | translate }}
				</mat-error>
			}
		</mat-form-field>
		<!-- Address State/Province -->
		<mat-form-field class="medium-height">
			<mat-label id="address-state">{{ 'payment-panel-address_state-province' | translate }}</mat-label>
			<input
				matInput
				[formControl]="addressForm.getControl('region')"
				aria-labelledby="address-state"
				data-cy="region"
				name="region"
				class="fullstory-ignore"
				autocomplete="address-level1">
			<!-- Error message -->
			@if (addressForm.getFieldError('region', 'required')) {
				<mat-error>
					{{ 'payment-panel-address_form-validation-state-province-required' | translate }}
				</mat-error>
			}
		</mat-form-field>
	</section>
	<section class="address-form-row" id="address-form-bottom">
		<!-- Address Postal Code -->
		<mat-form-field class="medium-height postal-code">
			<mat-label id="address-postal-code">{{ 'payment-panel-address_postal-code' | translate }}</mat-label>
			<input
				matInput
				[formControl]="addressForm.getControl('postal_code')"
				aria-labelledby="address-postal-code"
				data-cy="postal-code"
				class="fullstory-ignore"
				autocomplete="postal-code"
				maxlength="11">
			<!-- Error message -->
			@if (addressForm.getFieldError('postal_code', 'required')) {
				<mat-error>
					{{ 'payment-panel-address_form-validation-postal-code-required' | translate }}
				</mat-error>
			}
			@if (addressForm.getFieldError('postal_code', 'maxlength')) {
				<mat-error>
					{{ 'payment-panel-address_form-validation-postal-code-maxlength' | translate }}
				</mat-error>
			}
		</mat-form-field>
		<!-- Address Country Dropdown -->
		<country-picker
			class="fullstory-ignore"
			(countryChange)="addressForm.updateField('country', $event)">
		</country-picker>
	</section>
</form>
